var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{staticClass:"abow_dialog",attrs:{"center":"","width":"80%","close-on-click-modal":false,"before-close":_vm.closeDialog,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',[_c('iframe',{attrs:{"src":_vm.cpsHtml,"width":"100%","height":"500px","frameborder":"0"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }